<template>
  <div class="ui form" id="new-employee-form">
    <div v-if="loading" class="ui active inline center inverted dimmer">
      <div class="ui text loader">{{ $t('loading') }}...</div>
    </div>
    <div class="centered-header">
      <h2 class="ui header" style="color: #092442;">
        <i class="address card outline icon"></i>
        <div class="content">
          {{ $t('newEmployee') }}
        </div>
      </h2>
    </div>

    <br>

    <h4 class="ui dividing header">
      {{ $t('personalInfo') }}
    </h4>
    <div class="required field">
      <label for="name">{{ $t('name') }}</label>
      <div class="ui input">
        <input type="text"
               :placeholder="$t('employeeName')"
               v-model="employee.name"
               name="name">
      </div>
    </div>

    <div class="required two fields">
      <div class="field">
        <label for="date_of_birth">{{ $t('dateOfBirth') }}</label>
        <div style="text-align: center" class="ui calendar" :id="'date-of-birth'">
          <div class="ui input left icon">
            <i class="calendar icon"></i>
            <input type="text"
                   :placeholder="$t('dateOfBirth')"
                   readonly=""
                   name="day">
          </div>
        </div>
      </div>

      <div class="field">
        <label for="gender">{{ $t('chooseGender') }}</label>
        <select class="ui fluid search dropdown"
                id="employee-gender-search"
                v-model="employee.gender"
                name="gender">
          <option value="">{{ $t('chooseEmployeeGender') }}</option>
          <option :value="1">{{ $t('male') }}</option>
          <option :value="2">{{ $t('female') }}</option>
        </select>
      </div>
    </div>

    <div class="required two fields">
      <div class="field">
        <label for="nationalId">{{ $t('nationalId') }}</label>
        <div class="ui input left icon">
          <i class="address card icon"></i>
          <input type="number"
                 :placeholder="$t('nationalId')"
                 v-model="employee.job_info.national_id"
                 name="nationalId">
        </div>
      </div>

      <div class="field">
        <label for="chooseMaritalStatus">{{ $t('chooseMaritalStatus') }}</label>
        <select class="ui fluid search dropdown"
                id="marital-status-search"
                v-model="employee.job_info.marital_status"
                name="maritalStatus">
          <option value="">{{ $t('chooseMaritalStatus') }}</option>
          <option :value="1">{{ $t('married') }}</option>
          <option :value="2">{{ $t('single') }}</option>
        </select>
      </div>
    </div>

    <div class="required two fields">
      <div class="field">
        <label for="telephone">{{ $t('phone') }}</label>
        <div class="ui input left icon">
          <i class="phone icon"></i>
          <input type="number"
                 :placeholder="$t('phone')"
                 v-model="employee.home_phone"
                 name="homePhone">
        </div>
      </div>

      <div class="field">
        <label for="cell_phone">{{ $t('cellPhone') }}</label>
        <div class="ui input left icon">
          <i class="mobile icon"></i>
          <input type="number"
                 :placeholder="$t('cellPhone')"
                 v-model="employee.mobile"
                 name="cellPhone">
        </div>
      </div>
    </div>

    <div class="required field">
      <label for="address">{{ $t('address') }}</label>
      <textarea rows="2"
                :placeholder="$t('address')"
                v-model="employee.address"
                name="address"></textarea>
    </div>

<!--     <div class="field">
      <div class="ui grid">
        <div class="four wide column">
          <input type="file"
                 id="attachment"
                 style="display:none;"
                 @change="onFileChangeForCreate">
          <label for="attachment" class="ui left floated button">
            <i class="ui upload icon"></i>
            {{ $t('uploadCV') }}
          </label>
        </div>
        <div class="six wide column" style="margin-left: -95px;margin-top: 8px">
          <label for="" v-if="currentFile">
            <strong>{{ currentFile }}</strong>
          </label>
        </div>
      </div>
    </div>
 -->
    <!-- <br/> -->
    <br/>
    <!-- <div class="ui horizontal divider"> {{ $t('signUpInfo') }} </div> -->

    <h4 class="ui dividing header">
      {{ $t('signUpInfo') }}
    </h4>
    <div class="required three fields">
      <div class="field">
        <label for="email">{{ $t('email') }}</label>
        <div class="ui input left icon">
          <i class="at icon"></i>
          <input type="email"
                 :placeholder="$t('employeeEmail')"
                 v-model="employee.email"
                 name="email">
        </div>
      </div>
      <div class="field">
        <label for="password">{{ $t('password') }}</label>
        <div class="ui input left icon">
          <i class="lock icon"></i>
          <input type="password"
                 :placeholder="$t('password')"
                 v-model="employee.password"
                 name="password">
        </div>
      </div>
      <div class="field">
        <label for="password_confirmation">{{ $t('passwordConfirmation') }}</label>
        <div class="ui input left icon">
          <i class="lock icon"></i>
          <input type="password"
                :placeholder="$t('passwordConfirmation')"
                v-model="employee.password_confirmation"
                name="passwordConfirmation">
        </div>
      </div>
    </div>

    <br/>

    <h4 class="ui dividing header">
      {{ $t('jobInfo') }}
    </h4>

    <div class="required two fields">
      <div class="field">
        <label for="hire-date">{{ $t('hireDate') }}</label>
        <div style="text-align: center" class="ui calendar" :id="'hire-date'">
          <div class="ui input left icon">
            <i class="calendar icon"></i>
            <input type="text" :placeholder="$t('hireDate')" readonly="" name="hireDate">
          </div>
        </div>
      </div>

      <div class="field">
        <label for="job-title">{{ $t('jobTitle') }}</label>
        <div class="ui input left icon">
          <i class="briefcase icon"></i>
          <input type="text"
                 :placeholder="$t('jobTitle')"
                 v-model="employee.job_info.job_title"
                 name="jobTitle">
        </div>
      </div>

      <div class="field" style="width: 50%">
        <label for="salary">{{ $t('salary') }}</label>
        <div class="ui input left icon">
          <i class="pound sign icon"></i>
          <input type="number"
                 :placeholder="$t('salary')"
                 v-model="employee.job_info.salary_amount"
                 name="salary">
        </div>
      </div>
    </div>

    <div class="ui blue left floated button" style="background-color: #092442" @click="save()">
      {{ $t('submit') }}
    </div>

    <div v-if="notCreated" style="color: red">
      the record is not created some thing wrong with your data and here is a cause may your email is already used by another account.
    </div>
 </div>
</template>

<script>
export default {
  data () {
    return {
      currentFile: null,
      loading: false,
      notCreated: false,
      employee: {
        name: null,
        email: null,
        gender: null,
        date_of_birth: null,
        address: null,
        home_phone: null,
        mobile: null,
        password: null,
        password_confirmation: null,
        job_info: {
          national_id: null,
          hire_date: null,
          marital_status: null,
          job_title: null,
          salary_amount: null
        },
        resume: {
          name: null,
          attachment: null
        }
      }
    }
  },
  watch: {
    'employee.name': {
      handler: function () {
        this.employee.resume.name = this.employee.name + ' Resume'
      }
    }
  },
  mounted () {
    this.initGUI()
  },
  methods: {
    initGUI () {
      this.$nextTick(() => {
        $('#date-of-birth').calendar({
          type: 'date',
          onChange: (date) => {
            this.employee.date_of_birth = date
          },
          isDisabled: (date, mode) => {
            return false
          }
        })

        $('#hire-date').calendar({
          type: 'date',
          onChange: (date) => {
            this.employee.job_info.hire_date = date
          },
          isDisabled: (date, mode) => {
            return false
          }
        })

        $('#employee-gender-search').dropdown()
        $('#marital-status-search').dropdown()

        $('#new-employee-form').form({
          inline: true,
          on: 'blur',
          fields: {
            name: {
              rules: [
                {
                  type: 'empty',
                  prompt: 'Please enter employee name.'
                }
              ]
            },
            day: {
              rules: [
                {
                  type: 'empty',
                  prompt: 'Choose employee date of birth.'
                }
              ]
            },
            gender: {
              rules: [
                {
                  type: 'empty',
                  prompt: 'Please Choose employee gender.'
                },
                {
                  type: 'integer[1..2]',
                  prompt: 'Please Choose valid option.'
                }
              ]
            },
            nationalId: {
              rules: [
                {
                  type: 'empty',
                  prompt: 'Please enter employee national ID.'
                },
                {
                  type: 'integer',
                  prompt: 'Please enter a valid national ID.'
                },
                {
                  type: 'minLength[13]',
                  prompt: 'Please enter a valid national ID with at least 13 character.'
                }
              ]
            },
            maritalStatus: {
              rules: [
                {
                  type: 'empty',
                  prompt: 'Please choose employee marital status.'
                },
                {
                  type: 'integer[1..2]',
                  prompt: 'Please Choose valid option.'
                }
              ]
            },
            homePhone: {
              rules: [
                {
                  type: 'empty',
                  prompt: 'Please enter employee home phone.'
                },
                {
                  type: 'integer',
                  prompt: 'Please enter valid home phone number.'
                },
                {
                  type: 'minLength[7]',
                  prompt: 'Please enter at least 7 numbers.'
                }
              ]
            },
            cellPhone: {
              rules: [
                {
                  type: 'empty',
                  prompt: 'Please enter employee cell phone.'
                },
                {
                  type: 'integer',
                  prompt: 'Please enter valid cell phone number.'
                },
                {
                  type: 'minLength[11]',
                  prompt: 'Please enter valid cell phone number.'
                }
              ]
            },
            address: {
              rules: [
                {
                  type: 'empty',
                  prompt: 'Please enter employee address.'
                }
              ]
            },
            email: {
              rules: [
                {
                  type: 'empty',
                  prompt: 'Please enter employee email.'
                },
                {
                  type: 'email',
                  prompt: 'Please enter valid email.'
                }
              ]
            },
            password: {
              rules: [
                {
                  type: 'empty',
                  prompt: 'Please enter employee password.'
                },
                {
                  type: 'minLength[8]',
                  prompt: 'Please make the password length at least 8 characters.'
                }
              ]
            },
            passwordConfirmation: {
              rules: [
                {
                  type: 'empty',
                  prompt: 'Please enter password confirmation.'
                },
                {
                  type: 'match[password]',
                  prompt: 'Your confirmation is not like the password you wrote.'
                }
              ]
            },
            hireDate: {
              rules: [
                {
                  type: 'empty',
                  prompt: 'Please enter employee hire date.'
                }
              ]
            },
            jobTitle: {
              rules: [
                {
                  type: 'empty',
                  prompt: 'Please enter employee job title.'
                }
              ]
            },
            salary: {
              rules: [
                {
                  type: 'empty',
                  prompt: 'Please enter employee salary.'
                },
                {
                  type: 'number',
                  prompt: 'Plase enter a valid salary number. '
                }
              ]
            }
          }
        })
      })
    },
    save () {
      if ($('#new-employee-form').form('is valid')) {
        this.loading = true
        this.$http.post('employees', {
          employee: this.employee,
          clinic_id: this.getFromLocalStorage('clinicId')
        }).then(response => {
          this.loading = false
          this.navigateTo('Employees')
        }).catch(errorRes => {
          this.loading = false
          this.notCreated = true
        })
      }
    },
    onFileChangeForCreate (e) {
      var files = e.target.files || e.dataTransfer.files
      if (!files.length) {
        return
      }
      this.createImage(files[0])
    },
    createImage (file) {
      var reader = new FileReader()
      this.currentFile = file.name
      reader.onload = (e) => {
        this.employee.resume.attachment = e.target.result
      }
      reader.readAsDataURL(file)
    }
  }
}
</script>

<style scoped>
  .centered-header {
    display: flex;
    justify-content: center;
  }
  .virtical-center {
    display: flex !important;
    align-items: center !important;
    float: left;
  }
</style>



// WEBPACK FOOTER //
// src/components/employees/NewEmployee.vue